export const GAME_FRAME = {
  width: 1920,
  height: 1080,
  aspectRatio: "16 / 9"
} as const;

export const FOUNDATION_LIMITS = {
  activeCoreCap: 2,
  hardActiveCoreCap: 80,
  shellCount: 1,
  collectorLanes: 5
} as const;

export const SAVE_KEYS = {
  primary: "orbit_forge.save.v1",
  backup: "orbit_forge.save.v1.backup"
} as const;

export const SAVE_SCHEMA_VERSION = 1;

export const CORE_PHYSICS = {
  radius: 14,
  gravity: 460,
  dampingPerFrame: 0.997,
  minSpeed: 52,
  maxSpeed: 560,
  maxSubsteps: 12,
  hardActiveCoreCap: 80,
  overchargedActiveCap: 5,
  launchSpeed: 420,
  manualCooldownSeconds: 0.03,
  shellImpactCooldownSeconds: 0.04,
  coreImpactCooldownSeconds: 0.065,
  polarityCooldownSeconds: 0.08
} as const;

export const SHELL_RULES = {
  baseRadius: 150,
  radiusStep: 110,
  thickness: 12,
  baseGateDegrees: 27,
  baseSpeedDegrees: 22,
  startingShells: 1,
  maxShells: 3,
  manualBoostMultiplier: 2.8
} as const;

export const COLLECTOR_RULES = {
  y: 438,
  glowSeconds: 2.25,
  ranges: [
    { minX: -450, maxX: -270, multiplier: 2 },
    { minX: -270, maxX: -90, multiplier: 3 },
    { minX: -90, maxX: 90, multiplier: 2 },
    { minX: 90, maxX: 270, multiplier: 3 },
    { minX: 270, maxX: 450, multiplier: 2 }
  ]
} as const;

export const OVERDRIVE_RULES = {
  unlockLevel: 3,
  advancedUnlockLevel: 10,
  laneBoostUnlockLevel: 25,
  cooldownSeconds: 600,
  durationSeconds: 120,
  zoneHalfDegrees: 12,
  zoneMultiplier: 2,
  prestigeZoneMultiplier: 3,
  prestigeUsesPerWindow: 2,
  prestigeWindowSeconds: 3_600
} as const;

export const REACTOR_STORM_RULES = {
  unlockLevel: 5,
  level10CoreCount: 100,
  level30CoreCount: 200,
  prestigeCoreCount: 300,
  baseCoreCount: 50,
  cooldownSeconds: 300,
  overdriveStartLockSeconds: 60,
  fieldHalfWidth: 520,
  spawnY: 470,
  exitY: -540,
  spawnDurationSeconds: 14.5,
  eventCoreRadius: 7.2,
  spawnBudgetCap: 3.2,
  maxSpawnsPerFrame: 4,
  boardCount: 10,
  boardLength: 126,
  boardThickness: 13,
  firstHitAssistRangeY: 330,
  firstHitAssistStrength: 205,
  firstHitAssistMaxSpeed: 170,
  maxMultiplier: 24,
  highScaleUnlockLevel: 15,
  rewardScale: 7.5,
  highRewardScale: 18,
  highStartMultiplier: 2,
  overchargedMultiplier: 10
} as const;

export const LUCKY_SPARK_RULES = {
  unlockLevel: 1,
  minimumPlayTimeSeconds: 180,
  initialDelayMinSeconds: 45,
  initialDelayMaxSeconds: 95,
  activeDurationSeconds: 11,
  missedDelayMinSeconds: 85,
  missedDelayMaxSeconds: 150,
  claimedDelayMinSeconds: 85,
  claimedDelayMaxSeconds: 185,
  ticketChance: 0.22
} as const;

export const AUTO_LAUNCH_RULES = {
  unlockLevel: 2,
  storageCap: 5,
  spawnRadius: 78,
  spawnBudgetCap: 1.65,
  fullLimitBudgetClamp: 0.35,
  maxSpawnsPerFrame: 2,
  baseBallsPerSecond: 2,
  maxBallsPerSecond: 7.8,
  durationUpgradeUnlockLevel: 5,
  rateUpgradeUnlockLevel: 5,
  maxDurationLevel: 25,
  maxRateLevel: 30
} as const;
